module.exports = __webpack_public_path__ + "img/legend-high-alert.dc59ddd5.svg";